import { useState } from 'react';

const useAccordionState = () => {
  const [openReport, setOpenReport] = useState(true);
  const [openLetter, setOpenLetter] = useState(false);

  const toggleState = (
    state: boolean,
    fn: (boolean) => void,
    falseFn: (boolean) => void,
  ): (() => void) => {
    return () => {
      falseFn(false);
      fn(!state);
    };
  };

  return {
    report: [openReport, toggleState(openReport, setOpenReport, setOpenLetter)],
    letter: [openLetter, toggleState(openLetter, setOpenLetter, setOpenReport)],
  };
};

export default useAccordionState;
